import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { PureComponent } from 'react';
import IconChecked from "../Icon/IconRadioButtonCheck";
import { RadioRoot as Root } from "./styled";
import { LABEL_POSITION, SIZE } from "./constants";
import { radioPropTypes } from "./propTypes";

var _ref =
/*#__PURE__*/
___EmotionJSX(IconChecked, null);

var Radio =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Radio, _PureComponent);

  function Radio() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Radio.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        _inputRef = _this$props.inputRef,
        otherRootProps = _this$props.rootProps,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["className", "inputRef", "rootProps"]);

    var rootProps = _objectSpread({
      iconChecked: _ref,
      inputRef: function inputRef(ref) {
        if (_inputRef) {
          _inputRef(ref);
        }
      },
      rootProps: _objectSpread({
        className: className
      }, otherRootProps),
      type: 'radio'
    }, restProps);

    return ___EmotionJSX(Root, rootProps);
  };

  return Radio;
}(PureComponent);

_defineProperty(Radio, "displayName", 'Radio');

_defineProperty(Radio, "defaultProps", {
  labelPosition: LABEL_POSITION.end,
  size: SIZE.large
});

export { Radio as default };
Radio.propTypes = process.env.NODE_ENV !== "production" ? radioPropTypes : {};